export default __webpack_public_path__ + "static/media/trecking-1.a0835da1.png";